/**
 * routesFilterFields.js
 *
 * Advanced filter field catalog for the Routes grid. Field keys and operators match
 * RouteDynamicSpecification.java's leaf handling on the backend field-for-field.
 *
 * Note: Route's boolean flags (customerNominatedCarrier/autoAssign/autoTender/
 * autoAssignOnRecall) are supported by the backend Specification but deliberately left out of
 * this catalog for now -- the shared AdvancedFilterModal has no boolean-toggle value editor
 * today (only text/number/date/select), so exposing them would need frontend value-editor work
 * beyond this pass's scope.
 */

const TEXT_OPS = ["CONTAINS", "EQ"];
const DATE_OPS = ["GTE", "LTE", "EQ"];
const NUMBER_OPS = ["GTE", "LTE", "EQ"];

export const ROUTE_MODE_OPTIONS = ["FCL", "LCL", "FTL", "LTL", "TL", "AIR", "PARCEL"];

export const ROUTE_RULE_FIELDS = [
  {
    key: "routeCode", label: "Route Code", type: "text", group: "Route",
    ops: TEXT_OPS, backendField: "routeCode", placeholder: "e.g. RT-00123",
  },
  {
    key: "officeCode", label: "Office Code", type: "text", group: "Route",
    ops: TEXT_OPS, backendField: "officeCode", placeholder: "e.g. DIAMOND-MET",
  },
  {
    key: "laneCode", label: "Lane Code", type: "text", group: "Route",
    ops: TEXT_OPS, backendField: "laneCode",
  },
  {
    key: "contractCode", label: "Contract Code", type: "text", group: "Route",
    ops: TEXT_OPS, backendField: "contractCode",
  },
  {
    key: "mode", label: "Mode", type: "select", group: "Route",
    options: ROUTE_MODE_OPTIONS, ops: ["EQ", "NEQ", "IN"], backendField: "mode",
  },
  { key: "equipment", label: "Equipment", type: "text", group: "Route", ops: TEXT_OPS, backendField: "equipment" },

  { key: "origin", label: "Origin", type: "text", group: "Route", ops: TEXT_OPS, backendField: "origin" },
  { key: "destination", label: "Destination", type: "text", group: "Route", ops: TEXT_OPS, backendField: "destination" },

  { key: "carrier", label: "Carrier", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "carrier" },
  { key: "shipper", label: "Shipper", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "shipper" },
  { key: "carrierCode", label: "Carrier Code", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "carrierCode" },
  { key: "shipperCode", label: "Shipper Code", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "shipperCode" },

  { key: "capacity", label: "Capacity", type: "number", group: "Capacity", ops: NUMBER_OPS, backendField: "capacity" },
  { key: "commitment", label: "Commitment", type: "number", group: "Capacity", ops: NUMBER_OPS, backendField: "commitment" },
  { key: "distance", label: "Distance", type: "number", group: "Capacity", ops: NUMBER_OPS, backendField: "distance" },

  { key: "startDate", label: "Start Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "startDate" },
  { key: "endDate", label: "End Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "endDate" },
];
